import { formatDocument } from './document'

export const customer = (item) => {
  if (!item) return ''
  const customerName = item.real_estate?.name
  const customerDocument = item.real_estate?.cnpj
  const formattedDocument = customerDocument ? formatDocument(customerDocument) : false

  return `
    <p class="mb-0">
      <span class="body-2">
        ${customerName ?? '---'}
      </span>
      ${
        formattedDocument
          ? `<span class="d-block caption grey--text">${formattedDocument}</span>`
          :  ''
      }
    </p>
  `
}

export const isDraftAllowedBrazilianCustomer = () => {
  const bethaCnpj = '04528408000191';
  const qaCnpj = '16788643000181';
  const hausefulQaId = '06d58ef5-e0ae-4651-9fc2-6b59c67946d6'
  const qaEvictionsId = '300515f7-ac50-495b-b991-56a65049a744'
  const charlieCnpj = '37571863000129'
  const hausefulLoftFinancialSolutionsId = 'cf148959-0d60-4d8c-a703-3175a51d91fb'
  const tendaId = 'efa25682-8da3-4cba-96e6-b82e5e60cc7e'
  return localStorage.getItem('users_real_estate_cnpj') == qaCnpj
    || localStorage.getItem('users_real_estate_id') == hausefulQaId
    || localStorage.getItem('users_real_estate_id') == qaEvictionsId
    || localStorage.getItem('users_real_estate_cnpj') == bethaCnpj
    || localStorage.getItem('users_real_estate_cnpj') == charlieCnpj
    || localStorage.getItem('users_real_estate_id') == hausefulLoftFinancialSolutionsId
    || localStorage.getItem('users_real_estate_id') == tendaId
}
